export class TsProgetto {
    id:any;
    code:any;
    description:any;
    versione:any=0;
    active:any;
    id_legal_entity:any;
}
